import React, { Component } from "react";
import { connect } from "react-redux";
import MicroModal from "micromodal";

import { deleteListCallQueue, ActionDeleteCall } from "../actions";
import { DeleteListCall } from "../actions/websocket";

import Typography from "../components/Typography";
import Checkbox from "../components/manager-section/CheckboxIng/CheckboxIng";

import "./modals-file.css";

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteListCallQueue: (queueid, obs, iduser, sucess, mediaid) => {
    dispatch(deleteListCallQueue(queueid));
    dispatch(ActionDeleteCall(queueid, obs, iduser, sucess, mediaid));
  },
});

class NotifierModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: "",
      textInput: "",
      errorinput: false,
      contactclient: true,
    };
  }

  DeleteListCall(e, deletecdrid, deletequeueid, infousers, mediaid) {
    if (this.state.textInput !== "") {
      this.props.deleteListCallQueue(
        deletequeueid,
        this.state.textInput,
        infousers.id,
        this.state.contactclient,
        mediaid
      );
      MicroModal.close("modal__excluir");
    } else {
      this.setState({ errorinput: true });
    }
  }

  render() {
    const { InfoUsers } = this.props;

    return (
      <div
        className="modal micromodal-slide"
        id="modal__excluir"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__bloqueio__title"
          >
            <header className="modal__header">
              <Typography.H2 color={"blue-selected-4"} weight={700}>
                Motivo
              </Typography.H2>
              {/* <h2 className="modal__title" id="modal__bloqueio__title">
              Motivo
            </h2> */}

              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            {/* <div className="modal__header__bottom-line"></div> */}
            <main
              className="modal__content modal__content--small"
              id="modal__bloqueio__content"
            >
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content--left">
                      <Typography.H4 color={"black"}>
                        Contactou cliente?
                      </Typography.H4>
                      {/* <h3 className="modal-box__warning is-poppins">
                      Contactou cliente? <br />
                    </h3> */}
                    </div>

                    <div className="radio-content">
                      <div className="radio-button">
                        <input
                          type="radio"
                          id="radio-3"
                          name="radio"
                          value="radio-3"
                          defaultChecked={this.state.contactclient}
                          onChange={(e) =>
                            this.setState({ contactclient: true })
                          }
                        />
                        <label htmlFor="radio-3">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Sim</div>
                        </label>
                      </div>

                      <div className="radio-button">
                        <input
                          type="radio"
                          onChange={(e) =>
                            this.setState({ contactclient: false })
                          }
                          defaultChecked={this.state.contactclient}
                          id="radio-4"
                          name="radio"
                          value="radio-4"
                        />
                        <label htmlFor="radio-4">
                          <span>
                            <div className="mask"></div>
                          </span>

                          <div className="text">Não</div>
                        </label>
                        <br />
                        {/* <span
                        style={{
                          fontSize: "12px",
                          display: this.state.errorinput ? "block" : "none",
                        }}
                      >
                        Campo de preenchimento obrigatório
                      </span> */}
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-8 less-gap">
                    <Typography.H4 color={"black"}>
                      Campo de preenchimento obrigatório:
                    </Typography.H4>
                    <div
                      className={`anotc-add__textarea ${
                        this.state.errorinput && !this.state.textInput
                          ? "error-border"
                          : ""
                      } anotc-add__textarea__new`}
                    >
                      <textarea
                        name="anotc-add__textarea__input"
                        onChange={(e) =>
                          this.setState({ textInput: e.target.value })
                        }
                        id="anotc-add__textarea__input"
                        className="anotc-add__textarea__input"
                      ></textarea>
                    </div>
                  </div>

                  {/* <div className="modal__content__form__group modal__content__form__group--col-4">
                  <a
                    className="modal__content__form__group__button modal__content__form__group__button--white"
                    data-micromodal-close
                  >
                    Cancelar
                  </a>
                </div> */}
                  <div className="modal__content__form__group modal__content__form__group--col-4">
                    <a
                      className="modal__content__form__group__button"
                      onClick={(e) =>
                        this.DeleteListCall(
                          e,
                          this.props.deletequeueid,
                          this.props.deletecdrid,
                          InfoUsers,
                          this.props.mediaid
                        )
                      }
                    >
                      Enviar
                    </a>
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotifierModal);
